import App from 'app/app.js';
import 'app/service/EventService.js';

function ResetJobAction(EventService) {
  this.eventName = 'resetJob';

  this.dispatch = function () {
    EventService.dispatch(this.eventName, {});
  };

  this.register = function (listener) {
    return EventService.register(this.eventName, listener);
  };
}

App.service('ResetJobAction', ['EventService', ResetJobAction]);
